import { render, staticRenderFns } from "./MapaLocalizacaoGeografica.vue?vue&type=template&id=5aa41bf5&"
import script from "./MapaLocalizacaoGeografica.vue?vue&type=script&lang=js&"
export * from "./MapaLocalizacaoGeografica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports